import * as types from "./consts";

export const getTenantUserListRequest = (payload: string | undefined) => ({
  type: types.GET_TENANT_USER_LIST_REQUEST,
  payload,
});

export const deleteUserRowRequest = (payload: object | undefined) => ({
  type: types.DELETE_USER_ROW_REQUEST,
  payload,
});

export const updateUserRowRequest = (payload: object | undefined) => ({
  type: types.UPDATE_USER_ROW_REQUEST,
  payload,
});
